<template>
  <div>
    <ConfirmDialog />
    <Toast group="main" position="top-center" />
    <Toast group="headless" position="top-center">
      <template #container="{ message}">
        <section class="flex flex-row p-2 text-base gap-2 justify-between items-center cursor-pointer"
                 @click="onHeadlessClick(message.detail.caseID)">
          <section>
            <span>{{ message.detail.message }}</span>
          </section>
          <Button severity="secondary" text @click.stop="onHeadlessClick(message.detail.caseID)">
            <span class="material-symbols-rounded">open_in_new</span>
          </Button>
        </section>
      </template>
    </Toast>
    <router-view/>
  </div>
</template>

<script>
import {useMedicationStore} from 'stores/medication';
import {useMessageStore} from 'stores/message';
import {useAuthStore} from 'stores/auth';
import {useApplicationStore} from 'stores/application';
import {useActivationStore} from 'stores/activation';
import {useCaseStore} from "stores/case";
import packageInfo from "../package.json";
import { useServerStore } from "stores/server";
import Toast from 'primevue/toast';
import ConfirmDialog from 'primevue/confirmdialog';
import Button from "primevue/button";

export default {
  name: 'App',
  components: { Toast, ConfirmDialog, Button },
  setup() {
    const applicationStore = useApplicationStore();
    const authStore = useAuthStore();
    const actStore = useActivationStore();
    const messageStore = useMessageStore();
    const medicationStore = useMedicationStore();
    const caseStore = useCaseStore();
    const serverStore = useServerStore();
    return {
      applicationStore,
      authStore,
      actStore,
      caseStore,
      medicationStore,
      messageStore,
      serverStore
    };
  },
  data:     () => ({
    drawer: null,
  }),
  computed: {
    isAuthenticated() {
      return this.authStore.isAuthenticated();
    },
    serverVersion() {
      return this.applicationStore.serverVersion;
    }
  },
  mounted() {
    this.fetchGeofenceInfo();
  },
  methods: {
    logout: function () {
      this.authStore.authLogout()
      .then(() => {
        this.$router.push('/').catch((error) => {
          console.dir(error);
        });
      });
    },
    async onHeadlessClick(caseID) {
      this.$router.push({ name: "case", params: { caseNumber: caseID } });
    },
    async fetchGeofenceInfo() {
      const geofenceInfo = await this.serverStore.fetchGeofenceInfo();
      if (!geofenceInfo.enabled) {
        return;
      }
      const countryCode = await this.applicationStore.getCountryCode();
      if (!countryCode) {
        return;
      }

      if (geofenceInfo.blockedCountries.length > 0) {
        if (geofenceInfo.blockedCountries.includes(countryCode)) {
          await this.$router.push({ name: "blocked", query: { reason: "Geofence" } });
          return;
        }
      }

      if (geofenceInfo.allowedCountries.length > 0) {
        if (!geofenceInfo.allowedCountries.includes(countryCode)) {
          await this.$router.push({ name: "blocked", query: { reason: "Geofence" } });
        }
      }
    },
  },
  props: {
    source: String,
  },
};
</script>

<style>

</style>
